// Share this city (the share button in the player, U): a link to the city on screen and a line to go with it.
// Touch screens hand both to the system's share sheet (navigator.share); elsewhere a small menu copies the link or
// opens a network's own share page with it filled in (site/js/app.js).
// The link is the city's page on loficities.com whatever host this copy runs on (a preview deploy, localhost), and
// it carries nothing else: no look, style or weather, so the page's preview card always matches what opens.
//   node --test tests/share.test.mjs
const SITE = 'https://loficities.com/';
const VIA = 'loficitiesapp';                          // the site's own X account, named at the end of the post

/** What a city of the registry shares: { url, title, text }, as navigator.share takes them. */
export function shareOf(city) {
  return {
    url: `${SITE}${city.id}/`,
    title: `${city.name} Lofi · Lofi Cities`,
    text: `${city.name} lofi: a pixel-art city night with endless music`,
  };
}

/** The link as the menu shows it: loficities.com/tokyo */
export const shownLink = url => url.replace(/^https:\/\//, '').replace(/\/$/, '');

// %20 for a space, not URLSearchParams' +: Telegram and WhatsApp put a + into the message as it is
const query = params => Object.entries(params).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');

// The menu's rows, in this order (site/index.html has one <a data-share="id"> for each); href: the network's share page
export const SHARE_TARGETS = [
  { id: 'x', name: 'X', href: ({ url, text }) => `https://x.com/intent/post?${query({ text, url, via: VIA })}` },
  { id: 'whatsapp', name: 'WhatsApp', href: ({ url, text }) => `https://wa.me/?${query({ text: `${text} ${url}` })}` },
  { id: 'telegram', name: 'Telegram', href: ({ url, text }) => `https://t.me/share/url?${query({ url, text })}` },
  { id: 'reddit', name: 'Reddit', href: ({ url, text }) => `https://www.reddit.com/submit?${query({ url, title: text })}` },
];
